const visitedInput = () => {

  const inputs = document.querySelectorAll(".f-wrap input");
  inputs.forEach(input => {
    input.addEventListener("focus", () => {

      input.classList.add("--visited");
      if (input.parentElement.querySelector("label")) {
        input.parentElement.querySelector("label").classList.add("--visited");
        input.addEventListener("focusout", () => {

          if (input.value === "") {
            input.classList.remove("--visited");
            input.parentElement.querySelector("label").classList.remove("--visited");
          }
        })
      }

    })
    input.addEventListener("change", () => {

      input.classList.add("--visited");
      if (input.parentElement.querySelector("label")) {
        input.parentElement.querySelector("label").classList.add("--visited");
        input.addEventListener("focusout", () => {

          if (input.value === "") {
            input.classList.remove("--visited");
            input.parentElement.querySelector("label").classList.remove("--visited");
          }
        })
      }
    })
  });
}

visitedInput();
